import { NumericQuestion } from "./numeric-question";
import type { QuestionTypeRendererProps } from "./shared";

type RatingQuestionProps = QuestionTypeRendererProps<"rating">;

export default function RatingQuestionType(props: RatingQuestionProps) {
  return <NumericQuestion {...props} kind="rating" />;
}
